import * as actionTypes from "./actionTypes";
import Cookies from 'js-cookie';
import axios from 'axios';


const sessionExists = Cookies.getJSON('user-logged-in');
let stateUserInfo = {};
if (sessionExists) {
    stateUserInfo = {
        userLoggedIn: true,
       /* name: existingSession.firstName + ' ' + existingSession.lastName,
        id: existingSession.id,
        userEntityId: existingSession.entityId,
        user: existingSession*/
    }
}

const initialState = {
    name: '',
    id: undefined,
    userEntityId: undefined,
    userLoggedIn: false,
    showForgotPasswordForm: false,
    showResetPasswordForm: false,
    user: {timeZone: "Europe/Lisbon"},
    loginError: undefined,
    forgotPasswordError: undefined,
    resetPasswordError: undefined,

    loadingLoginRequest: false,
    loadingResetPasswordRequest: false,
    loadingForgotPasswordRequest: false,

    userData: {},
    loadingPersonalInfoRequest: false,
    loadPersonalInfoError: undefined,

    ...stateUserInfo
};

const authReducer = (state = initialState, {type, value, payload}) => {
    switch (type) {
        case actionTypes.LOGIN_REQUEST:
        case actionTypes.LOGOUT_REQUEST:
            return {
                ...state,
                loadingLoginRequest: true,
                loginError: undefined,
                forgotPasswordError: undefined,
                resetPasswordError: undefined
            };
        case actionTypes.LOGIN_FAILED:
            return {
                ...state,
                loginError: payload,
                loadingLoginRequest: false,
                userLoggedIn: false
            };
        case actionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                id: payload.id,
                loadingLoginRequest: false,
                userLoggedIn: true,
                name: payload.firstName + ' ' + payload.lastName,
                user: payload,
                userEntityId: payload.entityId,
                loginError: undefined
            };
        case actionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                loginError: payload,
                loadingLoginRequest: false,
                userLoggedIn: false,
                user: {
                    name: '',
                    password: '',
                    id: undefined,
                }
            };
        case actionTypes.LOGOUT_FAILED:
            return {
                ...state,
                loadingLoginRequest: false,
                error: 'Logout error'
            };
        case actionTypes.FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                loadingForgotPasswordRequest: true
            }
        case actionTypes.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPasswordError: undefined,
                loadingForgotPasswordRequest: false,
                showForgotPasswordForm: false
            };
        case actionTypes.FORGOT_PASSWORD_FAILED:
            return {
                ...state,
                loadingForgotPasswordRequest: false,
                forgotPasswordError: payload
            };
        case actionTypes.RESET_PASSWORD_REQUEST:
            return {
                ...state,
                loadingResetPasswordRequest: true
            }
        case actionTypes.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordError: undefined,
                loadingResetPasswordRequest: false,
                showResetPasswordForm: false
            };
        case actionTypes.RESET_PASSWORD_FAILED:
                return {
                    ...state,
                    loadingResetPasswordRequest: false,
                    resetPasswordError: payload
                };
        case actionTypes.COLLAPSE_FORGOT_PASSWORD_FORM:
            return {
                ...state,
                showForgotPasswordForm: value,
                showResetPasswordForm: false,
                forgotPasswordError: undefined,
                resetPasswordError: undefined
            };
        case actionTypes.COLLAPSE_RESET_PASSWORD_FORM:
            return {
                ...state,
                showResetPasswordForm: value,
                showForgotPasswordForm: false,
                forgotPasswordError: undefined,
                resetPasswordError: undefined
            };
        case actionTypes.GET_PERSONAL_INFO_REQUEST:
            return {
                ...state,
                loadingPersonalInfoRequest: true,
                loadPersonalInfoError: undefined
            };
        case actionTypes.GET_USER_PAGE_REFRESH_REQUEST:
            return {
                ...state,
                loadingPersonalInfoRequest: true,
                loadPersonalInfoError: undefined
            };
        case actionTypes.GET_USER_PAGE_REFRESH_SUCCESS:
            return {
                ...state,
                user: payload,
                name: payload.firstName + ' ' + payload.lastName,
                id: payload.id,
                userEntityId: payload.entityId,
                loadPersonalInfoError: undefined
            };
        case actionTypes.GET_PERSONAL_INFO_SUCCESS:
            return {
                ...state,
                loadingPersonalInfoRequest: false,
                userData: payload,
                loadPersonalInfoError: undefined
            };
        case actionTypes.GET_PERSONAL_INFO_FAILED:
            return {
                ...state,
                loadingPersonalInfoRequest: false,
                loadPersonalInfoError: payload,
            };
        case actionTypes.CHANGE_PERSONAL_INFO:
            return {
                ...state,
                name: payload.firstName + ' ' + payload.lastName,
                user: {
                    ...state.user,
                    language: payload.language,
                    timeZone: payload.timeZone,
                    firstName: payload.payload,
                    lastName: payload.lastName
                },
            }
        default:
            return state;
    }
};

export default authReducer;